import Bugsnag from '@bugsnag/js';
import { Heading, Pane } from 'evergreen-ui';
import { useEffect } from 'react';
import { Environment } from 'services/Environment';
import { useAppSelector } from 'store';

const removeCookies = async () => {
    return fetch(`${Environment.API_URL}/auth/logout`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
        },
    });
};

const handleLogout = async () => {
    try {
        await removeCookies();
        window.location.href = '/';
    } catch (error) {
        console.error(error);
        Bugsnag.notify(error as Error);
    }
};

export const Logout = () => {
    const { isLoading } = useAppSelector((state) => state.auth);

    useEffect(() => {
        if (!isLoading) {
            handleLogout();
        }
    }, [isLoading]);

    return (
        <Pane display="flex" justifyContent="center">
            <Pane width="80%" maxWidth={700} textAlign="center" marginY={80}>
                <Heading fontSize="2em" fontWeight={900}>
                    Logging out...
                </Heading>
            </Pane>
        </Pane>
    );
};

export default Logout;
